<template>
  <PcDialog
    v-if="self.isShow"
    :self="self"
    :title="dialogTitle"
    width="1100px"
    submitBtnText="确定"
    @submit="saveEmp"
    @close="close"
  >
    <div class="select-employee-main">
      <!-- 搜索栏 -->
      <PcTopSearch @searchclick="searchClick" @clear="clearClick">
        <template #nomal>
          <div class="searchitem pcmr16 pcw200">
            <YGJDeptCascader
              :self="searchForm"
              modelval="deptId"
              leftname="部门"
              @deptChange="onDeptChange"
            />
          </div>
          <div class="searchitem pcmr16 pcw200">
            <PcInput
              v-model="searchForm.userName"
              leftTitle="姓名"
              placeholder="请输入"
              clearable
            />
          </div>
          <div class="searchitem pcmr16 pcw200">
            <PcInput
              v-model="searchForm.mobile"
              leftTitle="手机号"
              placeholder="请输入"
              clearable
            />
          </div>
        </template>
      </PcTopSearch>

      <div class="employee-panel">
        <!-- 表格 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          :header-cell-style="tableStyle.tableHeaderCell"
          :cell-style="tableStyle.tableCellstyle"
          border
          height="420px"
          style="width: 100%"
        >
          <template #empty>
            <div v-if="!hasSearched" class="table-empty-tip">
              请选择部门或输入姓名或手机号后点击查询
            </div>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          />
          <el-table-column label="头像" width="70" align="center">
            <template #default="{ row }">
              <el-avatar :size="32" :src="row.avatar || defaultAvatar" />
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            min-width="100"
            show-overflow-tooltip
          />
          <el-table-column
            prop="position"
            label="职务"
            min-width="100"
            show-overflow-tooltip
          />
          <el-table-column
            prop="userId"
            label="账号"
            width="200"
            show-overflow-tooltip
          />
          <el-table-column prop="mobile" label="手机" width="120" />

          <el-table-column label="操作" width="60" align="center">
            <template #default="{ row }">
              <el-checkbox
                :model-value="isSelected(row)"
                :disabled="isRowDisabled(row)"
                @change="(val) => handleCheck(row, val)"
              />
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部：分页 + 已选数 -->
        <div class="bottom-bar">
          <div></div>
          <el-pagination
            background
            :current-page="pages.current"
            :page-size="pages.size"
            :page-sizes="[10, 20, 50]"
            layout="total, sizes, prev, pager, next"
            :total="pages.total"
            :pager-count="5"
            @size-change="sizeChange"
            @current-change="currentChange"
          />
        </div>
      </div>
    </div>
  </PcDialog>
</template>

<script>
import { getWecomWorkplaceUserPage } from "@/api/options.js";
import tableStyle from "@/assets/pc/js/config/publicTableStyle.js";
import defaultAvatar from "@/assets/img/avatar/avatardef.png";

export default {
  name: "SelectEmployeeDialog",
  props: {
    self: {
      type: Object,
      default: () => ({ isShow: false, defselect: [] }),
    },
    dialogTitle: {
      type: String,
      default: "添加企微员工",
    },
    /** 已选中的员工 id（列表中对应行不可再选） */
    disabledEmployeeIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["save"],
  data() {
    return {
      searchForm: {
        deptId: "",
        userName: "",
        mobile: "",
        departmentIds: [],
      },
      tableData: [],
      tableLoading: false,
      pages: {
        current: 1,
        size: 20,
        total: 0,
      },
      selectedList: [], //已选中的员工列表
      /** 是否已发起过员工查询（用于未搜索前表格提示） */
      hasSearched: false,
      tableStyle,
      defaultAvatar,
    };
  },
  computed: {
    disabledEmployeeIdSet() {
      const arr = this.disabledEmployeeIds || [];
      return new Set(
        arr
          .filter((id) => id !== null && id !== undefined && id !== "")
          .map((id) => String(id)),
      );
    },
  },
  methods: {
    onDeptChange({ id, ids }) {
      this.searchForm.deptId = id;
      this.searchForm.departmentIds = ids;
    },
    canSearch() {
      const userName = (this.searchForm.userName || "").trim();
      const mobile = (this.searchForm.mobile || "").trim();
      const departmentIds = this.searchForm.departmentIds || [];
      //只要有一个条件有数据，就认为可以搜索
      return !!userName || !!mobile || departmentIds.length > 0;
    },
    getList() {
      if (!this.canSearch()) {
        this.$message.warning("请选择部门或输入姓名或手机号后再点击查询");
        this.tableData = [];
        return;
      }

      const params = {
        current: this.pages.current,
        size: this.pages.size,
        userName: this.searchForm.userName || "",
        mobile: this.searchForm.mobile || "",
        departmentIds: this.searchForm.departmentIds || [],
      };

      this.tableLoading = true;

      getWecomWorkplaceUserPage(params)
        .then((res) => {
          const data = res?.data?.data || {};
          const records = data.records || [];
          this.tableData = records;
          this.pages.total = data.total || 0;
        })
        .finally(() => {
          this.tableLoading = false;
          this.hasSearched = true;
        });
    },
    isSelected(row) {
      return this.selectedList.some((item) => item.id === row.id);
    },
    isRowDisabled(row) {
      if (row == null || row.id === null || row.id === undefined) return false;
      return this.disabledEmployeeIdSet.has(String(row.id));
    },
    handleCheck(row, checked) {
      if (this.isRowDisabled(row)) return;
      if (checked) {
        if (!this.isSelected(row)) {
          this.selectedList.push({ ...row });
        }
      } else {
        this.selectedList = this.selectedList.filter(
          (item) => item.id !== row.id,
        );
      }
    },
    searchClick() {
      this.pages.current = 1;
      this.getList();
    },
    clearClick() {
      //清空搜索条件
      this.searchForm.deptId = "";
      this.searchForm.userName = "";
      this.searchForm.mobile = "";
      this.searchForm.departmentIds = [];
      //重置搜索
      this.hasSearched = false;
      this.pages.current = 1;
      this.pages.total = 0;
      this.tableData = [];
    },
    sizeChange(size) {
      this.pages.size = size;
      this.pages.current = 1;
      this.getList();
    },
    currentChange(current) {
      this.pages.current = current;
      this.getList();
    },
    saveEmp() {
      if (!this.selectedList.length) {
        this.$message.warning("请先选择员工");
        return;
      }
      this.$emit("save", this.selectedList);
      this.close();
    },
    close() {
      this.self.isShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select-employee-main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 520px;
}

.employee-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;

  .selected-count {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;

    em {
      font-style: normal;
      color: #28b8c3;
      font-weight: 600;
    }
  }
}

.table-empty-tip {
  padding: 24px 0;
  color: #909399;
  font-size: 13px;
}
</style>
